import React from 'react';
import PropTypes from 'prop-types';

import {styled} from '@mui/system';

import ActionButton from './ActionButton';


const StyledSpacer = styled('span')(({ theme }) =>({
    marginRight: theme.custom.spacing.default
}));


class FormButton extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <StyledSpacer>
                <ActionButton
                    text={this.props.text}
                    actionCallback={this.props.actionCallback}
                    actionData={this.props.actionData}
                    disabled={this.props.disabled}
                    hotKey={this.props.hotKey}
                    dataBt={this.props.dataBt}
                    />
            </StyledSpacer>
        );
    }
}

FormButton.propTypes = {
    text: PropTypes.string,
    actionCallback: PropTypes.func,
    actionData: PropTypes.object,
    disabled: PropTypes.bool,
    hotKey: PropTypes.string,
    dataBt: PropTypes.string
};

export default FormButton;
